




























































































































import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator'

@Component({})
export default class TagRangeInput extends Vue {
  @PropSync('minimum') min!: number|string|null
  @PropSync('maximum') max!: number|string|null
  @PropSync('include') inc!: boolean
  @Prop() type!: 'number'|'date'

  @Prop() remove!: (min: (string|number|undefined), max: (string|number|undefined), include: boolean) => void
  @Prop() toggle!: (min: (string|number|undefined), max: (string|number|undefined), include: boolean) => void
  @Prop() change!: () => void

  @Watch('min')
  @Watch('max')
  changeM () {
    this.change()
  }

  minMenu = false
  maxMenu = false

  minDate = ''
  maxDate = ''

  dateRules: FormRule[] = [
    v => !v || (/^\d{4}-\d{2}-\d{2}$/.test(v) && !isNaN(new Date(v).getTime())) || 'Must be a date of format YYYY-MM-DD',
  ]
}
